import styled from 'styled-components';

export const ShopBannerContainer = styled.div`
      @media screen and (max-width: 600px) {
            padding-left: 5px;
            padding-right: 5px;
      }
`;
